import React, { useState } from 'react'
import { PanelTitle } from './InventoryShared';

function RecipeManagementPage({ recipes }) {
    const [selectedRecipe, setSelectedRecipe] = useState(recipes[0]);
    const [autoDeduct, setAutoDeduct] = useState(selectedRecipe.autoDeduct);

    const selectRecipe = (name) => {
        const recipe = recipes.find(item => item.name === name);
        setSelectedRecipe(recipe);
        setAutoDeduct(recipe.autoDeduct);
    };

    return (
        <section className='inventory-panel inventory-form-page'>
            <PanelTitle title='Recipe Management' />
            <label className='inventory-field compact'>
                <span>Recipe Selection</span>
                <select value={selectedRecipe.name} onChange={(event) => selectRecipe(event.target.value)}>
                    {recipes.map(item => <option key={item.name}>{item.name}</option>)}
                </select>
            </label>
            <div className='inventory-log-list'>
                {selectedRecipe.ingredients.map(([name, qty]) => <div key={name}><strong>{name}</strong><span>{qty}</span></div>)}
            </div>
            <label className='inventory-toggle'>
                <span>Auto Stock Deduction</span>
                <input type='checkbox' checked={autoDeduct} onChange={(event) => setAutoDeduct(event.target.checked)} />
            </label>
            <div className='inventory-actions'>
                <button>Edit Recipe</button>
                <button>View Usage</button>
            </div>
        </section>
    );
}

export default RecipeManagementPage
